export default class ExternalLink {
    #element

    constructor(element) {
        this.#element = element
        this.#element.setAttribute('data-overridden', true)

        this.#bindEvents()
    }

    static isExternalLink(url) {
        try {
            return new URL(url).origin !== location.origin
        } catch (error) {
            return false
        }
    }

    static initAll(selector) {
        const isPortal = document.querySelector('body').classList.contains('portal')
        if (!isPortal) {
            return
        }

        const isApp = document
            .querySelector('body')
            .classList.contains('device-learnstrike-mobile-app')
        if (!isApp) {
            return
        }

        Array.from(document.querySelectorAll(selector), function (element) {
            if (element.href && ExternalLink.isExternalLink(element.href)) {
                new ExternalLink(element)
            }
        })
    }

    #bindEvents() {
        this.#element.addEventListener('click', this.#handleClick)
    }

    #handleClick = async (event) => {
        event.preventDefault()

        const eventData = {
            data: {
                type: 'link',
                attributes: {
                    link: this.#element.href,
                    type: 'external',
                },
            },
        }

        window.vuplexCommunicator.send(eventData)
    }
}
